<template>
  <div class="main">
    <base-card v-for="pizza in pizzas" :key="pizza.name">
      <v-card-title>{{ pizza.name }}</v-card-title>
      <v-card-text>{{ pizza.text }}</v-card-text>
      <v-card-actions class="flex text-right"
        ><v-spacer></v-spacer>{{ pizza.price }}</v-card-actions
      >
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pizzas: [
        {
          name: "Capricciosa",
          text: "Sallamë pule, kaçkavall qumështi, kërpudha",
          price: "100 den.",
        },
        {
          name: "Margherita",
          text: "Kaçkavall qumështi, salcë domateje",
          price: "100 den.",
        },
        {
          name: "Pepperoni-kulen",
          text: "Kaçkavall qumështi, kulen, salcë domateje",
          price: "130 den.",
        },

      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>
